import { defineComponent as _defineComponent } from 'vue'
import { WizardConfig } from 'ah-common-lib/src/models/progress';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationProgressFlow',
  props: {
    config: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})